import React from 'react';

interface PageLoadingSpinnerProps {
  message?: string;
  fullScreen?: boolean;
}

export const PageLoadingSpinner: React.FC<PageLoadingSpinnerProps> = ({
  message = 'Loading...',
  fullScreen = false,
}) => (
  <div className={`flex items-center justify-center ${fullScreen ? 'h-screen' : 'h-96'}`}>
    <div className="text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
      <p className="text-gray-500">{message}</p>
    </div>
  </div>
);
